<template>
  <p class="slogan" :class="{ dark }">
    <span v-for="(seg, i) in segments" :key="i" :class="seg.cls">{{ seg.text }}</span>
  </p>
</template>

<script>
import { company } from '@/data/company';

export default {
  name: 'SloganText',
  props: { dark: { type: Boolean, default: false } },
  computed: {
    segments() {
      const s = company.slogan;
      const out = [{ text: s.before, cls: '' }];
      s.parts.forEach((p, i) => out.push({ text: p, cls: i % 2 === 0 ? 'strong' : '' }));
      out.push({ text: s.brand, cls: 'brand' });
      out.push({ text: s.after, cls: '' });
      return out;
    },
  },
};
</script>

<style scoped>
.slogan { font-size: 40px; line-height: 1.4; font-weight: 600; letter-spacing: -0.02em; color: var(--muted-2); max-width: 1100px; }
.slogan .strong { color: var(--ink); font-weight: 700; }
.slogan .brand { color: var(--orange); font-weight: 700; }
.slogan.dark { color: #64748b; }
.slogan.dark .strong { color: #ffffff; }
@media (max-width: 900px) { .slogan { font-size: 24px; } }
</style>
